module.exports = __webpack_public_path__ + "std/img/raffle-wheel-border.cd8f912.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/raffle-wheel-border.png
// module id = f6Ih
// module chunks = 0 6